import { render } from "./BagicCompanySelector.vue?vue&type=template&id=d567b396"
import script from "./BagicCompanySelector.vue?vue&type=script&lang=js"
export * from "./BagicCompanySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__